<script lang="ts">
  import { i18n } from "../i18n.svelte";
  import { inview } from "../actions";
  import SectionHead from "./SectionHead.svelte";

  const fq = $derived(i18n.t.faq);
  let openIdx = $state(0);
  function toggle(i: number) {
    openIdx = openIdx === i ? -1 : i;
  }
</script>

<section class="section section--rule" id="faq">
  <div class="container narrow">
    <SectionHead label={fq.label} title={fq.title} />

    <div class="list">
      {#each fq.items as item, i}
        <div class="qa reveal" class:open={openIdx === i} use:inview={{ delay: i * 50 }}>
          <button class="q" onclick={() => toggle(i)} aria-expanded={openIdx === i}>
            <span>{item.q}</span>
            <span class="ico" aria-hidden="true"></span>
          </button>
          <div class="a-wrap">
            <p class="a">{item.a}</p>
          </div>
        </div>
      {/each}
    </div>
  </div>
</section>

<style>
  .narrow {
    max-width: 800px;
  }
  .list {
    margin-top: clamp(2rem, 1.5rem + 2vw, 3rem);
    border-top: 1px solid var(--line);
  }
  .qa {
    border-bottom: 1px solid var(--line);
  }
  .q {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    text-align: left;
    padding: 1.3rem 0;
    font-family: var(--font-mincho);
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--ink);
  }
  .ico {
    position: relative;
    flex: none;
    width: 18px;
    height: 18px;
  }
  .ico::before,
  .ico::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 14px;
    height: 2px;
    background: var(--green);
    transform: translate(-50%, -50%);
    transition: transform 0.35s var(--ease);
  }
  .ico::after {
    transform: translate(-50%, -50%) rotate(90deg);
  }
  .open .ico::after {
    transform: translate(-50%, -50%) rotate(0);
  }
  .a-wrap {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.4s var(--ease);
  }
  .open .a-wrap {
    grid-template-rows: 1fr;
  }
  .a {
    overflow: hidden;
    color: var(--ink-soft);
    font-size: 0.98rem;
    line-height: 1.85;
  }
  .open .a {
    padding-bottom: 1.3rem;
  }
</style>
